module.exports = __webpack_public_path__ + "static/media/carrito.abb0a7ce.png";